<script>
  import Vue from "vue";
  import funcMenu from  '../common/funcMenu'
  import mountFuncMenu from  '../common/mountFuncMenu'
  import drillDown from "../common/drillDown/drillDown"
  import mainVue from "../main"
  import Cookies from 'js-cookie';
  import API_search from "../api/api_search"
  import turf from "turf";
  import mapboxgl from 'mapbox-gl';
  import layerSrc from  '../config/layer_identify'
  import measureTool from "./mapElementBox/toolbar/measureComponent/measureComponent"
  import measureTool2 from "./mapElementBox/toolbar/measureComponent/measureTool"
  import xzqjson from "../config/xzqData"
  import { saveAs } from 'file-saver';

  let map = null;
  let eventBus = new Vue();

  export default {

    myappId:'64c0dba9d3dc4fd7b02a2e8f427930b1',//本应用，应用ID
    drawObj:"",
     importHeaders: {
      Authorization: Cookies.get("token"),
      // Appid: '75de62ff979e40b7ad933e426cbaf639',
      Appid: '64c0dba9d3dc4fd7b02a2e8f427930b1',
    },
    sampleMagMap:"",/*样点管理地图实例*/
    sampleTempMarker:"",/*样点管理临时新增marker*/
    sampleTempMarkerProp:"",

    addDraw:"",
    getAddDrawsdfsad(){
      if(this.addDraw){return this.addDraw};
      let addDraw = new measureTool2();
      addDraw.init(this.map123);
      this.addDraw = addDraw;
     return addDraw

    },


    measureTool2obj:"",

    initBounds:"",/*初始定位信息*/
    initXzqInfo:"",/*初始行政区信息*/
    drillDowmObj:"",/*下钻实例*/
    curXzqInfo:{/*当前行政区信息*/
      curAreaCode:"",
      curAreaName:"",
      curLevel:""
    },
    map,//全局的地图对象
    eventBus,//用于组件传值
    style:null,//存储初始化的地图样式
    year:'',//当前年份
    areaCode:'',//用户的登录区域
    projectId: '', // 项目id
    projectName: '', // 项目名称
    bigscreenProjectId: '',
    // 菜单配置和菜单权限
    menu: {
      checkMenuItemPermission: true,//使用用户管理返回的菜单权限进行控制，为false则不进行权限控制，默认使用前端配置的菜单
      menuItems: [],
      menuPermissions: []
    },
    // 路由页面权限
    routerPermission:{
      daping: false,
      tblt: false
    },

    machinery_map_locate_marker:"",/*农机列表定位marker*/

    /*作物代码和标的代码的关系*/
    bdzwdzgx:[
      {zwdm:"00",bddm:"00",name:"其他"},
      {zwdm:"06",bddm:"120201",name:"油菜"},
      {zwdm:"01",bddm:"120202",name:"花生"},
      {zwdm:"07",bddm:"110102",name:"冬小麦"},
      {zwdm:"03",bddm:"110101",name:"水稻"}
    ],

    /*作物代码和颜色的关系*/
    zwdmAndColor:[
      {"zwdm":"01","color":"#FF9999"},
      {"zwdm":"02","color":"#FFFF80"},
      {"zwdm":"06","color":"#00CC00"},
      {"zwdm":"03","color":"#96CA30"},
      {"zwdm":"16","color":"#FFCC33"},
      {"zwdm":"08","color":"#FFB94F"}
    ],

    /*基础数据,菜单ID和数据类型配置*/
    baseDataConfig:[
      {layerId:"xzq",layerName:"行政区数据",dataType:"行政区划"},
      {layerId:"yxsj",layerName:"影像数据",dataType:"遥感影像"},/*栅格*/
      {layerId:"demsj",layerName:"DEM数据",dataType:"DEM数据"},/*栅格*/
      {layerId:"dksj",layerName:"地块数据",dataType:"耕地"},
      {layerId:"sx",layerName:"水系",dataType:"水系"},
      {layerId:"lw",layerName:"路网",dataType:"路网"},
      {layerId:"poi",layerName:"POI",dataType:"POI"},
      {layerId:"tdly",layerName:"土地利用",dataType:"土地利用"},/*栅格*/
    ],

    /**
     * 根据作物代码获取颜色
     */
    getColorByZwdm(zwdm){
      let res = this.zwdmAndColor.find(item => { return item.zwdm === zwdm });
      if(res){
        return res.color;
      }else{
        return "";
      }

    },

    /**
     * 清除高亮图层，各种高亮
     */
    clearCurhilightLayer(){
      let hilightLayerIds = ["承保_highlighted_line","wtcx_cbdk_heilight","wtcx_wtdk_heilight"];
      let map =  this.map;
      hilightLayerIds.forEach(item => {if(map.getLayer(item)){map.removeLayer(item);}})
    },


    /**
     * 根据标的代码获取颜色
     */
    getColorByBddm(bddm){
      return this.getColorByZwdm(this.getZwdmByBddm(bddm))
    },

    /**
     * 根据标的代码获取作物代码
     */
    getZwdmByBddm(bddm){
      let res = this.bdzwdzgx.find(item => { return item.bddm === bddm });
      if(res){
        return res.zwdm;
      }else{
        return "";
      }
    },


    /**
     * 使用测量
     * draw_point   测量点
     *draw_line_string 测量线
     *draw_polygon 测量多边形
     */
    measure(type,callBack){
      measureTool.measure(this.map,type,callBack);
    },

    measure2(type,callBack){
      if(!this.measureTool2obj){
        this.measureTool2obj = new measureTool2();
        this.measureTool2obj.init(this.map)
      }
      this.measureTool2obj.measure(type,callBack);
    },

    deactive(){
      measureTool.unbindEvent();
    },

    /**
     * 清除测量
     */
    clearMeasure(){
      measureTool.clear();
    },

    /**
     * 获取测量draw实例
     */
    getDraw(){
      return measureTool.getDraw();
    },



    /*控制多个按钮，只要一个是激活状态*/
    handleTabStyle(clickDomId,className,activeClassName){
      let clickDom = document.getElementById(clickDomId);
      if(clickDom.className.includes(activeClassName)){return}
      let curSelectedDom = document.getElementsByClassName(activeClassName);
      if(curSelectedDom.length != 0){
        for(let i = 0;i < curSelectedDom.length;i++ ){
          curSelectedDom[i].className = clickDom.className + " " +  className;
        }
      }
      clickDom.className =  clickDom.className + " " +  activeClassName;
    },



    /**
     * @param xzqcode 行政区代码
     * @param isHiligh 是否高亮行政区
     * @param hiligheColor 行政区高亮颜色
     * @param isCenterAndBound  是否使用centerAndBounds定位
     * @param boundsOptions  fitboudns的选项
     * @param subtractor 使用中心加级别定位情况下定位级别从最大级别减此参数作为修正级别
     */
    async locateXzq({xzqcode = "2110",isHiligh = true ,hiligheColor = "#DEA6DE",isCenterAndBound = false,boundsOptions,frommap = '',zoomnum = "", subtractor = ""}){
      let bounddata = await  API_search.getEnvByadmin({'qhdm': xzqcode});
      if(!bounddata.data || bounddata.data.length === 0){
        /*如果没有查询到定位信息则定位到系统初始位置*/
        this.locateXzq({xzqcode:Cookies.get("areaCode"),"isCenterAndBound":true})
        return
      }
      let locObj = bounddata.data[0];
      if (locObj.env) {
        let env = JSON.parse(locObj.env);
        if (env) {
          let e_bound = turf.bbox(env);
          let bounds = new mapboxgl.LngLatBounds(new mapboxgl.LngLat(e_bound[0], e_bound[1]), new mapboxgl.LngLat(e_bound[2], e_bound[3]));
          let xzqData = xzqjson.data;/*所有行政区数据*/
          let areaCode =  xzqcode || Cookies.get('areacode');/*当前登录用户所属行政区代码*/
          let curXzq = xzqData.find(item => {return item.id == areaCode});/*查询当前用户行政区数据*/
          let map = frommap || this.map;
          // let e_bound = [...curXzq.bbox[0],...curXzq.bbox[1]];
          // let bounds = new mapboxgl.LngLatBounds(new mapboxgl.LngLat(e_bound[0], e_bound[1]), new mapboxgl.LngLat(e_bound[2], e_bound[3]));
          //this.initBounds = bounds;
          if(isCenterAndBound){
            let center = bounds.getCenter();
            map.setZoom(zoomnum || (this.getZoomByAreaCode(xzqcode) - (subtractor || 0.1)) );
            map.setCenter(center);
          } else{
            if(boundsOptions){map.fitBounds(bounds,boundsOptions)}else{map.fitBounds(bounds)}
          }
          if(isHiligh){
            this.hilightXzq({map:frommap || this.map ,areaCode,hiligheColor});/*高亮定位行政区*/
          }
        }
      }
    },

    /**
     * 根据区划代码获取Zoom级别
     */
    getZoomByAreaCode(areaCode){
      if(!areaCode){return ""}
      let areaCodeLength = areaCode.toString().length;
      switch (areaCodeLength){
        case 1 :
          let curLevelInfo = layerSrc.layer_Drilldown.find(item => {return item.level === 0 })
          return curLevelInfo.maxzoom
          break;

        case 2 :
          let curLevelInfo1 = layerSrc.layer_Drilldown.find(item => {return item.level === 1 })
          return curLevelInfo1.maxzoom
          break;

        case 4 :
          let curLevelInfo2 = layerSrc.layer_Drilldown.find(item => {return item.level === 2 })
          return curLevelInfo2.maxzoom
          break;

        case 6 :
          let curLevelInfo3 = layerSrc.layer_Drilldown.find(item => {return item.level === 3 })
          return curLevelInfo3.maxzoom
          break;

        case 9 :
          let curLevelInfo4 = layerSrc.layer_Drilldown.find(item => {return item.level === 4 })
          return curLevelInfo4.maxzoom
          break;

        case 12 :
          let curLevelInfo5 = layerSrc.layer_Drilldown.find(item => {return item.level === 5 })
          return curLevelInfo5.maxzoom
          break;

      }

    },


    /**
     * @param map
     * @param areaCode
     */
    hilightXzq({map,areaCode,hiligheColor = "#DEA6DE"}) {
      let curLayerInfo = this.getLayerInfoByCode(areaCode);
      let curXzqlayer = map.getLayer(curLayerInfo.layerId);
      if(!curXzqlayer){return}
      let highlightLayerId = curXzqlayer.source + "_bk";//该ID命名规则同下钻模块中添加行政区高亮边框图层的id命名规则一样，不与下钻中的图层冲突
      this.clearLocatedHilight();/*清除上次高亮*/
      if (!map.getLayer(highlightLayerId)) {
        this.lastLocationLayerId = highlightLayerId;
        map.addLayer({//添加高亮边框图层
          "id": highlightLayerId,
          "type": "line",
          "source": curXzqlayer.source,
          "source-layer": curXzqlayer.sourceLayer,
          "minzoom": curXzqlayer.minzoom,
          "layout": {},
          "paint": {
            "line-color": hiligheColor,
            "line-opacity": 1,
            "line-width": 4
          },
          "filter": ["==", "qhdm", areaCode]
        });
      }else{
        map.setLayoutProperty(highlightLayerId,'visibility', 'visible');
        map.setFilter(highlightLayerId,["==", "qhdm", areaCode])
      }
    },

    /**
     * 清除定位高亮效果
     */
    clearLocatedHilight(){
      if(this.lastLocationLayerId && this.map.getLayer(this.lastLocationLayerId)){
        this.map.removeLayer(this.lastLocationLayerId);
        this.lastLocationLayerId = "";
      };
    },

    /**
     * 通过行政区代码获取该级别行政区图层信息
     */
    getLayerInfoByCode(areaCode){
      let curxzq = "";
      if(areaCode.length == 1 ){curxzq = "全国";}
      if(areaCode.length == 2 ){curxzq = "省";}
      if(areaCode.length == 4 ){curxzq = "地市";}
      if(areaCode.length == 6 ){curxzq = "县";}
      if(areaCode.length == 9 ){curxzq = "乡镇";}
      if(areaCode.length == 12 ){curxzq = "村";}
      return  layerSrc.layer_Drilldown.find(item => {return item.levelName === curxzq });
    },


    /**
     * 获取当前用户信息
     */
    getCurUserInfo(){
      return {
        deptCode:Cookies.get("deptCode"),
        deptName:Cookies.get("deptName"),
        deptId:Cookies.get("deptId"),
        userId:Cookies.get("userId"),
        userName:Cookies.get("userName"),
        areaCode:Cookies.get("areaCode"),
        areaName:Cookies.get("areaName")
      }
    },


    /**
     * 激活下钻功能
     */
    activeDrillDown(map,options,clickCallBack,zoomBack,zoomBackInsideLevel){
      if(this.drillDowmObj){
        this.drillDowmObj.active(map, options, clickCallBack, zoomBack, zoomBackInsideLevel);
      }else{
        this.drillDowmObj = new drillDown()
        this.drillDowmObj.active(map, options, clickCallBack, zoomBack, zoomBackInsideLevel);
      }
    },

    /**
     * 卸载下钻功能
     */
    inActiveDrillDown(){
      if(this.drillDowmObj){
        this.drillDowmObj.inActive();
      }
    },

    /**
     * 获取上次下钻点击返回的参数
     */
    getDrillDownLastParams(){
      if(this.drillDowmObj){
        return [this.drillDowmObj.curClickObj,this.drillDowmObj.ptArrResult,this.drillDowmObj.areaArrResult];
      }else{
        return "";
      }
    },

    /**
     * 获取当前下钻点击返回的参数
     */
    getCurClickObj(){
      if(this.drillDowmObj){
        return this.drillDowmObj.curClickObj;
      }else{
        return "";
      }
    },

    /**
     * 根据区划代码查询行政区级别
     */
    getCurXzqInfo(areaCode){
      let curxzq = "";
      if(areaCode.length == 1 ){
        curxzq = "全国";
      }
      if(areaCode.length == 2 ){
        curxzq = "省";
      }
      if(areaCode.length == 4 ){
        curxzq = "地市";
      }
      if(areaCode.length == 6 ){
        curxzq = "县";
      }
      if(areaCode.length == 9 ){
        curxzq = "乡镇";
      }
      if(areaCode.length == 12 ){
        curxzq = "村";
      }
      return  layerSrc.layer_Drilldown.find(item => {return item.levelName === curxzq });
    },

    /**
     * 根据区划代码查询行政区级别
     */
    getXzqLevel (areaCode) {
      let xzqLevalName = "";
      let level = "";
      if(areaCode.length == 2 ){
        xzqLevalName = "全国";
        level = 0;
      }
      if(areaCode.length == 2 ){
        xzqLevalName = "省";
        level = 1;
      }
      if(areaCode.length == 4 ){
        xzqLevalName = "地市";
        level = 2;
      }
      if(areaCode.length == 6 ){
        xzqLevalName = "县";
        level = 3;
      }
      if(areaCode.length == 9 ){
        xzqLevalName = "乡镇";
        level = 4;
      }
      if(areaCode.length == 12 ){
        xzqLevalName = "村";
        level = 5;
      }
      return {
        xzqLevalName :xzqLevalName,
        level :level
      }
    },

    /**
     * 登录后定位到初始位置
     */
    initLocation(curAreaCode){
      this.areaCode = curAreaCode;
      this.initXzqInfo = this.getCurXzqInfo(curAreaCode);
      if(!curAreaCode){
        console.log("初始定位失败,无初始区域代码!");
        return;
      }
      //根据areaCode获得行政区划位置
      API_search.getEnvByadmin({'qhdm': curAreaCode}).then(res => {
        if (res.code !== 0 ) {
          this.warning(res.msg);
          return;
        }
        if(res.data.length == 0){
          console.log("返回初始定位数据为空");
          return;
        }
        let locObj = res.data[0];
        if (locObj.env) {
          this.hilightCurXzq(this.map,curAreaCode);
          let env = JSON.parse(locObj.env);
          if (env) {
            let e_bound = turf.bbox(env);
            let bounds = new mapboxgl.LngLatBounds(new mapboxgl.LngLat(e_bound[0], e_bound[1]), new mapboxgl.LngLat(e_bound[2], e_bound[3]));
            this.initBounds = bounds;
            this.initLocate();
          }
        }else {
          console.log("无定位env.");
        }
      }).catch(res => {
        this.error("获取初始定位信息错误");
      });
    },

    /**
     * 20180830高飞添加，用于根据当前登录的账户所属的行政区代码高亮该行政区边框
     * @param map
     * @param areaCode
     */
    hilightCurXzq(map,areaCode) {
      let that = this;
      let curxzq = "";
      if(areaCode.length == 1 || areaCode == 1){//gf 如果长度是1，表示全国权限账户，
        setTimeout(function () {
          that.hightQg(map);
        },500);
        return;
      }
      if(areaCode.length == 2 ){
        curxzq = "省";
      }
      if(areaCode.length == 4 ){
        curxzq = "地市";
      }
      if(areaCode.length == 6 ){
        curxzq = "县";
      }
      if(areaCode.length == 9 ){
        curxzq = "乡镇";
      }
      if(areaCode.length == 12 ){
        curxzq = "村";
      }
      let obj = layerSrc.layer_Drilldown.find(function (func) {//根据当前行政级别取查找对应的行政区级别的资源
        return func.levelName === curxzq;
      });
      let curXzqlaye = map.getLayer(obj.layerId);
      if(!curXzqlaye) return; // 行政区边框图层未加载时不执行后续高亮代码
      let highlightLayerId = curXzqlaye.source + "_bk";//该ID命名规则同下钻模块中添加行政区高亮边框图层的id命名规则一样，不与下钻中的图层冲突
      this.removeMapLayer(highlightLayerId) //清除高亮图层
      if (!map.getLayer(highlightLayerId)) {
        map.addLayer({//添加高亮边框图层
          "id": highlightLayerId,
          "type": "line",
          "source": curXzqlaye.source,
          "source-layer": curXzqlaye.sourceLayer,
          "minzoom": curXzqlaye.minzoom,
          "layout": {},
          "paint": {
            "line-color": "#dea6de",
            "line-opacity": 1,
            "line-width": 4
          },
          "filter": ["==", "qhdm", areaCode]
        });
      }
    },

    hightQg (map) {
      let highlightLayerId = "dt_gj" + "_bk";//该ID命名规则同下钻模块中添加行政区高亮边框图层的id命名规则一样，不与下钻中的图层冲突
      if (!map.getLayer(highlightLayerId)) {
        map.addLayer({//添加高亮边框图层
          "id": highlightLayerId,
          "type": "line",
          "source": "dt_gj",
          "source-layer": "dt_gj",
          "minzoom": 1,
          "layout": {
            "visibility": "visible"
          },
          "paint": {
            "line-color": "#dea6de",
            "line-opacity": 1,
            "line-width": 4
          },
        });
      }
    },

    /**
     * 定位到初始化位置
     */
    initLocate(){
      if(this.initBounds){
        this.map.fitBounds(this.initBounds, {padding: {top: 100, bottom:100, left: 0, right: 0}});//设置地图定位范围
        this.hilightCurXzq(this.map,this.areaCode);
      }
    },

    /**
     * 判断传入的行政区代码是否在当前登录账户所属行政区范围内
     */
    isCurXzqRange(qhdm){
      // if(qhdm.startsWith(Cookies.get('curAreaCode')) ||  Cookies.get('areaCode') == 1 ){
      if(qhdm.startsWith(Cookies.get('curAreaCode')) ||  Cookies.get('curAreaCode') == 1 ){
        return true;
      }
      return false;
    },

    /**
     *重置系统,让系统回到登录状态
     */
    resetSystem(){
      /* this.inactiveAllMountedFunction(); /!*卸载所有挂载功能*!/
       this.inActiveCurModule();/!*卸载当前功能模块*!/
       let map = this.map;
       let oldStyle = JSON.parse(JSON.stringify(this.style));
       map.setStyle(oldStyle);//将原始的style设置回去*/
      this.initLocate();
    },

    /**
     * 执行所有模块的clear函数
     */
    clearAllMap(){
      this.clearMountedFunction();
      funcMenu.clearCurrent();
      this.clearQhdw();/*区划定位功能在此单独处理*/
    },

    /**
     * 执行区划定位功能的clear函数
     */
    clearQhdw(){
      mountFuncMenu.clearById("qhdw");
    },


    /**
     * 执行当前打开的所有挂载功能的clear函数
     */
    clearMountedFunction(){
      mountFuncMenu.clearAll();
    },

    /**
     * 卸载所有当前打开的挂载功能
     */
    inactiveAllMountedFunction(){
      mountFuncMenu.inActiveAll();
    },

    /**
     * 卸载所有当前打开的挂载功能
     */
    inActiveCurModule(){
      funcMenu.inActiveCurModule();
    },


    /**
     * 根据图层ID删除图层
     */
    removeMapLayer(layerid){//根据ID删除图层的函数
      if(this.map && this.map.getLayer(layerid)){
        this.map.removeLayer(layerid);
      }
    },


    /**
     * 成功提示
     * @param content 提示的内容
     * @param duration  提示持续时间
     */
    success(content,duration = 2000,showclose = true){
      mainVue.$message.success({
        showClose: showclose,
        message: content,
        duration: duration
      });
    },
    /**
     * 错误提示
     * @param content 提示的内容
     * @param duration  提示持续时间
     */
    error(content,duration=2000,showclose = true){
      mainVue.$message.error({
        showClose: showclose,
        message: content,
        duration: duration
      });
    },

    /**
     * 警告提示
     * @param content 提示的内容
     * @param duration  提示持续时间
     */
    warning(content,duration=2000,showclose = true){
      mainVue.$message.warning({
        showClose: showclose,
        message: content,
        duration: duration
      });
    },

    // 返回按钮权限，未查询到的返回null
    getButtonAuthority(funcId) {
      // 如果菜单权限控制为false，则不进行按钮权限检查
      if (!this.menu.checkMenuItemPermission) {
        return null
      }
      var res = {}
      let menuPermission = null
      try {
        // 获取权限信息
        let menuPermissions = this.menu.menuPermissions
        if (menuPermissions == null) return null
        // 两层循环找出模块权限
        for (let menuPermission1 of menuPermissions) {
          if (menuPermission1.children == null) continue
          for (let menuPermission2 of menuPermission1.children) {
            if (menuPermission2.path == funcId) {
              menuPermission = menuPermission2
              break
            }
          }
        }
        // 循环模块的按钮权限，赋值为true，返回
        if (menuPermission == null || menuPermission.children == null) return null
        for (let btnPermission of menuPermission.children) {
          if (btnPermission.path && btnPermission.path.trim() != "") {
            res[btnPermission.path] = true
          }
        }
        return res
      }
      catch (e) {
        return null
      }
    },
    /**
     * 处理大于interval数量级的数据采用万元、万亩等单位
     * @param val  传过来的值
     * @param unitA 小单位
     * @param unitB 大单位
     * @param num 小数点保留位数(默认2)
     * @param interval 比较值(默认100000)，大于interval则使用大单位
     * @returns {string} 返回数值加对应单位
     */
    unitConversion: function (val, unitA, unitB, num, interval) {
      if(typeof(val)==='string'){//zfy
        return val;
      }
      if (!interval) {
        interval = 10000;//以万为间隔值
      }
      if (!num) {
        num = 2
      }
      if (!val) {
        val = 0
      }
      if(unitA && unitB){
        if (val >= interval) {
          return ((val / interval).toFixed(num) + unitB);
        } else {
          return (Math.floor(val)===val)?(val+unitA):(val.toFixed(num) + unitA);//如果本身就是整数，则不保留小数位
        }
      }else{
        if (val >= interval) {
          return ((val / interval).toFixed(num) + (unitB||''));
        } else {
          return (Math.floor(val)===val)?(val):(val.toFixed(num));//如果本身就是整数，则不保留小数位
        }
      }

    },
    /**
     * 处理数字与数字单位：万、亿
     * @param val  传过来的值
     * @returns {val: number, unit: string} 返回数值和对应单位：万、亿
     */
    unitConversionSplit: function (val) {
      if(typeof(val)==='string'){//zfy
        return val;
      }
      let interval = 10000;//以万为间隔值
      let unitA = '万';
      let unitB = '亿';
      let unitC = '万亿';
      let num = 2;
      let data = {
        val: val,
        unit: unitA
      }
      if (!val) {
        val = 0
      }
      if (val>=interval && val<interval*interval) {
        data.val = Math.round((val / interval)*100)/100;
        data.unit = unitA;
      } else if(val<interval){
        data.val = (Math.floor(val)===val)?(val):Math.round(val*100)/100;
        data.unit = '';
      } else if(val>=interval*interval && val<interval*interval*interval){
        data.val = Math.round(val / (interval*interval)*100)/100;
        data.unit = unitB;
      } else{
        data.val = Math.round(val / (interval*interval*interval)*100)/100;
        data.unit = unitC;
      }
      return data
    },

    /**
     * 日期比较函数函数
     * @param  开始日期startDate  结束日期endDate  'yyyy-MM-dd'
     * @returns {bool}
     */
    //时间比较函数
    dateCompare:function(startDate,endDate){
      var start=  new Date(startDate);
      var end=   new Date(endDate)
      if (start.getTime() > end.getTime()) {
        return false;
      }
      return true;
    },

    // 时间戳转为字符串 type=time：年月日-时分秒
    /**
     * 时间戳转为字符
     *  type：time年月日-时分秒(默认)
     *  type：date年月日
     */
    timetoDate: function (timestamp,type="time") {
      if(!timestamp){
        return "--"
      }
      var date = new Date(timestamp)
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      var time = "";
      if(type=='time'){
        time = year + '-' + (String(month).length > 1 ? month : '0' + month) + '-' +
              (String(day).length > 1 ? day : '0' + day) + ' ' + (String(hour).length > 1 ? hour : '0' + hour) + ':' + (String(minute).length > 1 ? minute : '0' + minute)
              + ':' + (String(second).length > 1 ? second : '0' + second)
      }else if(type=='date'){
        time = year + '-' + (String(month).length > 1 ? month : '0' + month) + '-' +
              (String(day).length > 1 ? day : '0' + day)
      }
      return time
    },

    /**
     * 四舍五入函数（处理有些浏览器解析toFIxed函数为五舍六入）
     * @param num 需要转换千分符的数字
     * @returns {string}
     */
    toFixedSelf: function (num) {//传入数字，返回四舍五入的两位小数
      var numstr = String(num);
      if (numstr.indexOf(".") >= 0) {
        var portnum = numstr.indexOf(".") + 3;
        if (parseInt(numstr.slice(portnum, portnum + 1)) == 5) {
          num = num + 0.001
        }
        return num.toFixed(2);
      }else{
        return num
      }
    },
    /**
     * 将数字转换为带千分符
     * @param num 需要转换千分符的数字
     * @returns {string}
     */
    formatNumberRgx: function (num) {
      var parts = num.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },

    /**
     * 打印
     */
    doPrint(tableId){
      if(!tableId){return};
      let tableToPrint = document.getElementById(tableId).cloneNode(true);//将要被打印的表格
      let tHeader = tableToPrint.getElementsByClassName("el-table__header")[0];/*获取header Table*/
      let tBody = tableToPrint.getElementsByClassName("el-table__body")[0];/*获取body Table*/
      let tFooter = tableToPrint.getElementsByClassName("el-table__footer")[0];/*获取footer Table*/

      /*处理header样式*/
      if(tHeader){
        this.addBorder(tHeader,"th");
        tHeader.style["border-left"] = "1px solid #9A9A9A";
        tHeader.style["border-top"] = "1px solid #9A9A9A";
      }

      /*处理body样式*/
      if(tBody){
        this.addBorder(tBody,"td");
        tBody.style["border-left"] = "1px solid #9A9A9A";
      }

      /*处理footer样式*/
      if(tFooter){
        this.addBorder(tFooter,"td");
        tFooter.style["border-left"] = "1px solid #9A9A9A";
      }

      /*执行打印*/
      let newWin= window.open("");//新打开一个空窗口
      newWin.document.write((tHeader ? tHeader.outerHTML : "") + (tBody ? tBody.outerHTML:"") + (tFooter ? tFooter.outerHTML:"") );//将表格添加进新的窗口
      newWin.document.close();//在IE浏览器中使用必须添加这一句
      newWin.focus();//在IE浏览器中使用必须添加这一句
      newWin.print();//打印
      newWin.close();//关闭窗口

    },

    addBorder(domArr,tagName){
      let domTdArr = domArr.getElementsByTagName(tagName);
      for(let i = 0; i < domTdArr.length;i++){
        domTdArr[i].style["border-right"] = "1px solid #9A9A9A"
        domTdArr[i].style["border-bottom"] = "1px solid #9A9A9A";
        domTdArr[i].style["text-align"] = "center";
        //domTdArr[i].style["overflow"] = "auto";
      }
    },

    getFilter(layerId,filter){
      let map = this.map;
      let oldFilter = map.getLayer(layerId).filter;
      if(!filter){return [[...oldFilter],""]}
      let orginFilter = "";
      if(!oldFilter || oldFilter == "undefined" ){
        return ["",filter];
      }else{
        orginFilter = [...oldFilter];
      }
      let newFilter = [];
      if(["all","any"].includes(filter[0])){
        filter.splice(0,1);
        newFilter = ["all"];
        if(["all","any"].includes(orginFilter[0])){/*通过*/
          /*遍历旧filter，以新filter的ke为准*/
          orginFilter.splice(0,1);
          let temp = []
          orginFilter.forEach(item => {
            let findIndex = filter.findIndex(itemF => {return item[1] === itemF[1] && itemF[0] != "has" });
            if(findIndex < 0){
              temp.push(item)
            }
          });
          newFilter = ["all",...filter,...temp];
        }else{/*通过*/
          let findres = filter.find(itemF => {return itemF[1] === orginFilter[1]  && itemF[0] != "has" });
          if(findres){
            newFilter = ["all",...filter];
          }else{
            newFilter = ["all",...filter,orginFilter];
          }
        }
      }else{
        if(["all","any"].includes(orginFilter[0])){/*通过*/
          orginFilter.splice(0,1);
          newFilter = ["all"];
          let findIndex = orginFilter.findIndex(itemF => {return itemF[1] === filter[1]  && itemF[0] != "has" });
          if(findIndex >= 0){
            orginFilter.splice(findIndex,1)
          }
          newFilter = ["all",filter,...orginFilter];
        }else{/*通过*/
          if(filter[0] === orginFilter[0]){
            newFilter = filter;
          }else{
            newFilter = ["all",filter,orginFilter];
          }
        }
      }
      return [[...oldFilter],newFilter];
    },

    downloadBlobFile(file, name, extension, type){
      let timeStr = new Date().toJSON();
      let fileName = timeStr.substring(0,10).replace(/-/g,'') + "_" +
                      timeStr.substring(11,19).replace(/:/g,'') +"_" +
                      name + "." + extension;
      let blob;
      if(extension==="xls"){
        blob = new Blob([file],{type: "application/vnd.ms-excel;charset=utf-8"})
      }else if(extension==="zip"){
        blob = new Blob([file],{type: "application/zip;charset=utf-8"})
      }else if(extension==="doc" ){
        blob = new Blob([file],{type: "application/msword;charset=utf-8"})
      }

      if (type == 'project') {
        fileName = name +'_'+ timeStr.substring(0,10).replace(/-/g,'')
      }
      saveAs(blob,fileName);
    }


  }
</script>



// WEBPACK FOOTER //
// src/components/Globle.vue